module.exports = __webpack_public_path__ + "static/media/ic-history.b7ba6420.svg";